import { translate } from '../../../utils/translation'

export const useConsolidationTranslation = () => ({
  consolidation: translate('Consolidação'),
  toReceive: translate('A receber'),
  ToExpire: translate('A expirar'),
  Expired: translate('Expirados'),
  notToExpire: translate('Não expira'),
  toReceiveLabel: translate('Saldo a receber'),
  ToExpireLabel: translate('Valores que podem expirar'),
  ExpiredLabel: translate('Valores que expiraram da sua carteira'),
  notToExpireLabel: translate('Valores que não expiraram da sua carteira'),
  cashback: translate('Cashback'),
  points: translate('Pontos'),
})
